<div [style.display]="selected ? '' : 'none'">
    <ng-template #tabHeader>
        <div
            class="agpr-entityResults"
            role="group"
            [attr.aria-label]="'Discover.targeting.result.entityResultControls' | localize"
        >
            <!-- top row -->
            <h2
                *ngIf="heading"
                class="agpr-entityResults-heading"
            >
                {{ heading | localize }}
            </h2>
            <div class="agpr-entityResults-toolbar agpr-entityResults-toolbar-Top">
                <h3 class="u-srOnly">{{ 'toolbar' | localize }}</h3>
                <div class="agpr-entityResults-toolbar-Top-Container">
                    <agpr-filter-dropdown
                        [id]="id + '.resultsFilters'"
                        [showQuickFilter]="true"
                        [quickFilterPlaceholder]="quickFilterPlaceholder"
                        [ariaLabel]="quickFilterAriaLabel"
                        [ariaDescribedBy]="id + '.filters.chips'"
                    ></agpr-filter-dropdown>
                </div>
                <agpr-sort-order
                    id="entityResultTab-sortOrder"
                    [isDisabled]="!results?.length"
                    tooltip="Discover.targeting.rhp.filter.tooltips"
                    optionKey="enumValue"
                    optionLabel="displayString"
                ></agpr-sort-order>
            </div>
            <agpr-filter-chips
                *ngIf="chipsVisible"
                class="agpr-entityResults-filterChips"
                [id]="id + '.filters.chips'"
            >
            </agpr-filter-chips>

            <!-- second row -->
            <div class="agpr-targetingResults-listBuilder-rhp">
                <agpr-dropdown
                    [id]="id + '.targeting.add.to.type'"
                    class="agpr-targetingResults-listBuilder-type"
                    [options]="targetingAddToOptions"
                    [(ngModel)]="addToType"
                    [bindToValue]="true"
                    (ngModelChange)="selectTargetingType()"
                ></agpr-dropdown>

                @if (addToType === targetingAddToTypes.LIST) {
                    <agpr-autocomplete
                        #listBuilderDropdown
                        class="agpr-entityResults-listBuilder-dropdown"
                        [id]="id + '.listBuilderDropdown'"
                        labelField="name"
                        placeholder="Discover.listBuilder.widget.placeholder.dropdown"
                        [dropdown]="true"
                        dropdownMode="current"
                        [(ngModel)]="selectedLists"
                        [customOptions]="listBuilderOptions"
                        (itemSelected)="updateListBuilder()"
                        [suggestions]="targetingLists$"
                        [multiSelection]="true"
                        [agprTooltip]="'Discover.listBuilder.widget.tooltip.dropdown' | localize"
                        tooltipPosition="top"
                        [ariaLabel]="'Discover.listBuilder.widget.placeholder.dropdown'"
                        [showHiddenOption]="true"
                    ></agpr-autocomplete>
                    <span class="agpr-entityResults-listBuilder-lock">
                        <agpr-button
                            class="agpr-entityResults-toolbarIcon--lock"
                            [style]="buttonTypes.icon"
                            [id]="id + '.listBuilder.lock'"
                            (click)="listPickerService.toggleWorkingListsLock()"
                            [icon]="workingListsLocked ? 'fa-regular fa-duotone fa-lock' : 'fa-regular fa-duotone fa-unlock'"
                            [tooltip]="workingListsLocked ? 'Discover.listBuilder.widget.tooltip.unlock' : 'Discover.listBuilder.widget.tooltip.lock'"
                            tooltipPosition="top"
                        ></agpr-button>
                    </span>
                } @else {
                    <agpr-autocomplete
                        [id]="id + '.distributionBuilderDropdown'"
                        #listBuilderDropdown
                        class="agpr-targetingResults-listBuilder-dropdown"
                        labelField="name"
                        placeholder="Discover.distributionBuilder.widget.placeholder.dropdown"
                        [dropdown]="true"
                        dropdownMode="current"
                        [(ngModel)]="selectedDistributions"
                        (itemSelected)="updateDistributionBuilder()"
                        [suggestions]="distributions$"
                        [multiSelection]="true"
                        [pTooltip]="'Discover.distributionBuilder.widget.tooltip.dropdown' | localize"
                        tooltipPosition="top"
                        [ariaLabel]="'Discover.distributionBuilder.widget.placeholder.dropdown'"
                        [showHiddenOption]="true"
                    ></agpr-autocomplete>

                    <span class="agpr-targetingResults-listBuilder-lock">
                        <agpr-button
                            class="agpr-targetingResults-toolbarIcon--lock"
                            [style]="buttonTypes.icon"
                            [id]="id + '.distributionBuilder.lock'"
                            (click)="distributionPickerService.toggleWorkingDistributionsLock()"
                            [icon]="workingDistributionsLocked ? 'fa-regular fa-duotone fa-lock' : 'fa-regular fa-duotone fa-unlock'"
                            [tooltip]="workingDistributionsLocked ? 'Discover.distributionBuilder.widget.tooltip.unlock' : 'Discover.distributionBuilder.widget.tooltip.lock'"
                            tooltipPosition="top"
                        ></agpr-button>
                    </span>
                }

                <agpr-button
                    class="agpr-entityResults-listBuilder-addToButton"
                    [ngClass]="{'agpr-targetingResults-listBuilder-addToDistButton' : addToType === targetingAddToTypes.DISTRIBUTION}"
                    [id]="id + '.addTo'"
                    [style]="buttonTypes.icon"
                    [icon]="addToType === targetingAddToTypes.LIST ? 'fa-regular fa-duotone fa-user-plus' : 'fa-kit-duotone fa-agpr-add-distribution'"
                    [disabled]="!results?.length || selectedResults.length === 0"
                    (click)="addTo()"
                    [tooltip]="addToType === targetingAddToTypes.LIST ? 'Discover.listBuilder.widget.tooltip.addButton' : 'Discover.distributionBuilder.widget.tooltip.addButton'"
                    tooltipPosition="left"
                ></agpr-button>
            </div>

            <!-- third row -->
            @if (selectedListsChips?.length || selectedDistributionsChips?.length) {
                <div class="agpr-targetingResults-listBuilder-rhp-chipContainer">
                    @if (addToType === targetingAddToTypes.LIST) {
                        <agpr-chip-container
                            #listChipsComponent
                            [id]="id + '.selectedLists.chips'"
                            [chips]="selectedListsChips"
                            (removeChip)="listPickerService.removeWorkingListByIndex($event)"
                        ></agpr-chip-container>
                        <agpr-button
                            *ngIf="selectedLists.length > 1"
                            class="agpr-targetingResults-toolbarIcon-clear"
                            [style]="buttonTypes.icon"
                            id="listBuilderClear"
                            (click)="clearListChips()"
                            icon="agpr-i-clear"
                            tooltip="Discover.listBuilder.widget.tooltip.clearAll"
                            tooltipPosition="top"
                        ></agpr-button>
                    }
                    @else {
                        <agpr-chip-container
                            #listChipsComponent
                            [id]="id + '.selectedDistributions.chips'"
                            [chips]="selectedDistributionsChips"
                            (removeChip)="distributionPickerService.removeWorkingDistributionByIndex($event)"
                        ></agpr-chip-container>
                        <agpr-button
                            *ngIf="selectedDistributions.length > 1"
                            [id]="id + '-distributionBuilderClear'"
                            class="agpr-targetingResults-toolbarIcon-clear"
                            [style]="buttonTypes.icon"
                            (click)="clearDistributionChips()"
                            icon="fa-kit-duotone fa-agpr-remove-all"
                            tooltip="Discover.distributionBuilder.widget.tooltip.clearAll"
                            tooltipPosition="top"
                        ></agpr-button>
                    }
                </div>
            }

            <!-- bottom row -->
            <div class="agpr-entityResults-toolbar agpr-entityResults-toolbar-Bottom agpr-entityResults-toolbar-Bottom-Container">
                <agpr-checkbox
                    id="entityResultsTab_selectAll"
                    [binary]="true"
                    [disabled]="!results?.length"
                    hiddenLabel="selectAll"
                    [ngModel]="results?.length > 0 && selectedResults?.length === results?.length"
                    (ngModelChange)="toggleSelectAll()"
                >
                    <span
                        class="agpr-entityResults-toolbar-Bottom-totalCount-value"
                        id="entityResultsTab_selectAll_selectedCount"
                    >
                        {{ allSelected ? (total | number) : ((selectedResults?.length | number) || '0') }}
                        <span class="agpr-entityResults-toolbar-Bottom-totalCount-text">
                            {{ 'Paginator.of' | localize }}
                            <span
                                class="agpr-entityResults-toolbar-Bottom-totalCount-value"
                                id="entityResultsTab_selectAll_totalCount"
                            >
                                {{ (total | number) || '0'}}
                            </span>
                            {{'Paginator.selected' | localize}}
                        </span>
                    </span>
                </agpr-checkbox>
                <agpr-minimal-paginator [isDisabled]="!results?.length"></agpr-minimal-paginator>
            </div>
            <div
                *ngIf="selectedResults?.length === results?.length && total > selectedResults?.length"
                class="agpr-entityResults-selectAllNotice"
            >
                <agpr-message [severity]="messageSeverityEnums.info">
                    <span *ngIf="!allSelected">
                        {{
                        'Discover.targeting.result.selectAll.notice.page' | localize : {
                            count: selectedResults.length
                            }
                        }}
                    </span>
                    <span *ngIf="allSelected">
                        {{
                        'Discover.targeting.result.selectAll.notice.all' | localize : {
                            count: total
                            }
                        }}
                    </span>
                    <agpr-button
                        *ngIf="!allSelected"
                        [label]="'Discover.targeting.result.selectAll.hyperlink.select' | localize : {
                            count: total
                        }"
                        (click)="selectAllResults()"
                        [style]="buttonTypes.link"
                        class="agpr-entityResults-selectAllNotice-link"
                    ></agpr-button>
                    <agpr-button
                        *ngIf="allSelected"
                        [label]="'Discover.targeting.result.selectAll.hyperlink.clear' | localize"
                        (click)="toggleSelectAll()"
                        [style]="buttonTypes.link"
                        class="agpr-entityResults-selectAllNotice-link"
                    ></agpr-button>
                </agpr-message>
            </div>
        </div>
    </ng-template>
    <div
        [agprLoading]="searchLoading"
        class="agpr-entityResults"
    >
        <h3 class="u-srOnly">{{ 'results' | localize }}</h3>
        <ul
            [id]="id + '_entityResults'"
            *ngIf="results"
            agprListKeyboardNavigation
            [focusOnChild]="true"
            [list]="results"
            focusableElementCustomSelector=".agpr-targetingResults-card"
        >
            <li *ngFor="let result of results; let i = index">
                <agpr-entity-list-card
                    [id]="id + '_entityResultCard_' + i"
                    [disableSelection]="allSelected"
                    [entity]="result"
                    [addToType]="addToType"
                    [selectedResults]="selectedResults"
                    (selectionChanged)="selectedResults = $event"
                    (showRhpTakeOver)="showRhpTakeOver.emit($event)"
                ></agpr-entity-list-card>
            </li>
        </ul>
        <div
            *ngIf="!total && noContentInfo"
            class="agpr-entityResults-noContentInfo"
        >
            <agpr-message
                [severity]="messageSeverityEnums.noContent"
                [useWhiteBg]="true"
                [style.display]="hiddenNoContentMessage ? 'none' : 'block'"
            >
                <span> {{ noContentInfo | localize }} </span>
            </agpr-message>
        </div>
    </div>
    <ng-template #tabFooter>
        <ng-container
            *ngIf="!targetingMode else normal"
        >
            <agpr-action-bar *ngIf="showActionsButton && selectedResults?.length > 0">
                <ng-template #right>
                    <agpr-split-button
                        label="Discover.targeting.actions.actions"
                        [style]="buttonTypes.tertiary"
                        [caretDown]="false"
                        panelPositionY="top"
                        panelPositionX="right"
                        [options]="actions"
                    ></agpr-split-button>
                </ng-template>
            </agpr-action-bar>
        </ng-container>

        <ng-template #normal>
            <agpr-action-bar *ngIf="showActionsButton">
                <ng-template #right>
                    <agpr-button
                        label="Discover.targeting.actions.actions"
                        [style]="buttonTypes.tertiary"
                        (click)="openBatchActions()"
                    ></agpr-button>
                </ng-template>
            </agpr-action-bar>
        </ng-template>
    </ng-template>
</div>
